/* eslint-disable import/prefer-default-export */
export const GRAPHQL_LIMIT = 9999;

export const CLINICARD_NAMES = {
  LIFE_CONTROL: 'Mate van zelfregie',
  STEPS: 'steps',
  PROSTHESIS: 'prosthesis_questionnaire',
  VAS: 'vas_painscore',
  VAS_CHESTPAIN: 'vas_chestpain',
  VAS_SHORTBREATH: 'vas_shortbreath',
  MOOD: 'mood',
  PHOTO: 'photo',
  NOTE: 'note',
  BMI: 'bmi',
  EXERCISE: 'exercises',
  CSI: 'caregiver_strain_index',
  PREPARE_VISIT: 'prepare_visit',
  GOALS: 'goals',
  SATURATION: 'saturation',
  HEARTRATE: 'heartrate',
  MOTHER_MILK: 'mother_milk_hc_name',
};

export const SUPPORTED_DATE_FORMATS = [
  'D-M-YY',
  'D-M-YYYY',
  'D-MM-YY',
  'D-MM-YYYY',
  'DD-M-YY',
  'DD-M-YYYY',
  'DD-MM-YY',
  'DD-MM-YYYY',
];

export const CAREINSTITUTION_CATEGORIES = [
  { value: 'vsv', text: 'vsv' },
  { value: 'hospital', text: 'hospital' },
  { value: '1st line', text: '1st_line' },
  { value: 'echo center', text: 'echo_center' },
  { value: 'maternity care', text: 'maternity_care' },
  { value: 'lactation expert', text: 'lactation_expert' },
];

export const CHILD_STATUS = [
  { value: 'admitted', text: 'admitted' },
  { value: 'discharged', text: 'discharged' },
  { value: 'deceased', text: 'deceased' },
];
